var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWebflow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.049 0.108398L21.1902 19.1217H11.9301L16.056 11.2418H15.8709C12.4671 15.6009 7.38851 18.4705 0.152344 19.1217V11.3509C0.152344 11.3509 4.78149 11.0811 7.50283 8.25851H0.152344V0.108549H8.41351V6.81177L8.59892 6.81102L11.9747 0.108549H18.2224V6.76927L18.4079 6.76898L21.9103 0.108398H31.049Z",
    fill: "#146EF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWebflow);
export default __webpack_public_path__ + "static/media/ic_webflow.05075f23ca7f0e3f297cef01bf68c098.svg";
export { ForwardRef as ReactComponent };